<template>
  <v-app-bar
    color="black"
    dense
    dark
    min-height="6.5vh"
    max-height="6.5vh"
    flat
    class="header-bar"
  >
    <v-menu bottom left>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item to="/dashboard" v-if="!dealerViewingUser">
          <v-list-item-title>
            <v-icon>$dashboard</v-icon>
            {{ $t('navigation.dashboard') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item to="/customers" v-if="!dealerViewingUser">
          <v-list-item-title>
            <v-icon>$customerManagementIcon</v-icon>
            {{ $t('navigation.customerManagement') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item to="/locations" v-if="dealerViewingUser">
          <v-list-item-title>
            <v-icon>mdi-map-marker</v-icon>
            {{ $t('navigation.locations') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item to="/admin" v-if="!dealerViewingUser && showDealerMyUsers">
          <v-list-item-title>
            <v-icon>mdi-account-multiple</v-icon>
            {{ $t('navigation.administration') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-toolbar-title class="toolbar-logo">
      <i v-if="dealerViewingUser"
        ><img
          alt="1"
          style="height: 100%; width: 160px; max-height: 6vh"
          svg-inline
          src="@/assets/svg/3xLogo.svg"
      /></i>
      <i v-else
        ><img
          alt="2"
          style="height: 95%; width: 160px"
          svg-inline
          src="@/assets/svg/3xDealerPortalLogo.svg"
      /></i>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <AccountMenu />
  </v-app-bar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AccountMenu from './../AccountMenu.vue'

export default defineComponent({
  name: 'DealerUserMobileNav',
  props: {
    dealerViewingUser: {
      type: Boolean,
      required: true,
    },
    showDealerMyUsers: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AccountMenu,
  },
  methods: {
    routeToCustomers() {
      this.$router.push('/customers')
    },
  },
})
</script>
